import { gql, useApolloClient, useLazyQuery } from "@apollo/client";
import { saveAs } from "file-saver";

export const DOWNLOAD_ATTACHMENT_QUERY = gql`
  query GetTaskAttachment($taskId: String, $attachmentName: String) {
    task(taskId: $taskId) {
      attachment(name: $attachmentName)
    }
  }
`;

export interface AttachmentTaskQuery {
  task: Task;
}

export interface Task {
  attachment: string;
}

export const useDownloadAttachment = () => {
  const client = useApolloClient();

  const downloadAttachment = async (taskId: string, attachmentName: string) => {
    const { data, networkStatus } = await client.query<AttachmentTaskQuery>({
      query: DOWNLOAD_ATTACHMENT_QUERY,
      notifyOnNetworkStatusChange: true,
      variables: {
        taskId,
        attachmentName,
      },

      fetchPolicy: "network-only", // tvinger nettverkskall, ikke cache
    });
    if (data.task.attachment) {
      // Decode Base64 to binary
      const byteCharacters = atob(data.task.attachment);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      // Create Blob from binary
      const blob = new Blob([byteArray], { type: "application/pdf" });

      saveAs(blob, attachmentName);
    } else {
      console.error("Attachment not found");
    }
  };

  return { downloadAttachment };
};
